import React, { useState, useEffect, useContext, useMemo } from "react";
import axios from "axios";
import TextInput from "components/Input/TextInput.js";
import IntInput from "components/Input/IntInput.js";
import Button from "@mui/material/Button";
import EditButton from "components/CustomButtons/Button.js";
import { makeStyles, withStyles } from "@mui/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import AppBar from "@mui/material/AppBar";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import Divider from "@mui/material/Divider";
import ImageList from "@mui/material/ImageList";
import { NotificationManager } from "react-notifications";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle";
import DateInput from "components/Input/DateInput.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import styled from "styled-components";
import Dialog from "@mui/material/Dialog";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { vuepagetext } from "variables/vues";
import { campaigncharttext, campaignviewtext } from "variables/MBM/campaign";
import { chartsourceData, charttypefullData, chartgranularityData, chartgranularityfullData } from "variables/lists/vues"
import DataTable from "react-data-table-component";
import _ from "lodash";
import ChartDialog from "./ChartDialog";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import AddChartToView from "./AddChartToView";
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import uuid from "react-uuid";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 80,
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const useStyles2 = makeStyles(styles);
const UseSweetAlertStyle = makeStyles(sweetAlertStyle);
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "28ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "28ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;
const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;
const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;
const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;


function ViewEditionDialog(props) {
  const memv2versionactive = localStorage.getItem('memv2version') || 0;

  const { closeModal, refetch, setLoading, currentView, chartsList, views, setViews, setModification } = props;

  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = advancedSearchContext;

  const [name, setName] = useState(currentView?.viewName || "Nouvelle vue");
  //Keep it in case we want to use it
  // const [groups, setGroups] = useState(view?.parameters?.general?.groups ? "" + view.parameters?.general?.groups : "");
  // const [datebegin, setDatebegin] = useState(view?.parameters?.general?.datebegin || "");
  // const [dateend, setDateend] = useState(view?.parameters?.general?.dateend || "");
  const [column, setColumn] = useState(currentView?.column || "");
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const [charts, setCharts] = useState(currentView?.charts || []);
  const [currentchart, setCurrentchart] = useState("");
  const [openchart, setOpenchart] = useState(false);

  const [existingcharts, setExistingcharts] = useState([]);
  const [existingChartsData, setExistingChartsData] = useState([]);

  const handleNameChange = (event) => {
    setName(event.target.value);
    currentView.viewName = event.target.value;
    setModification(true);
  };
  // const handleDatebeginChange = (event) => {
  //   setDatebegin(event.target.value);
  // };
  // const handleDateendChange = (event) => {
  //   setDateend(event.target.value);
  // };
  const handleColumnChange = (event) => {
    setColumn(event.target.value);
    currentView.column = Number(event.target.value);
    setModification(true);
  };
  // const handleGroupsChange = (value) => {
  //   setGroups(value);
  // };

  const classes = useStyles();
  const classes2 = useStyles2();
  const [value, setValue] = useState("0");

  useEffect(() => {
    if (currentView && currentView.charts) {
      let tmpdata = currentView.charts;
      tmpdata.forEach((chart) => {
        if (!chart.source) {
          chart.source = 'existing';
        }
        if (!chart.version) {
          chart.version = 'v1';
        }
      });
      setCharts(tmpdata);
      currentView.charts = tmpdata;
    }
  }, []);


  useEffect(() => {
    var existingchartstmp = [];
    for (var element in chartsList) {
      existingchartstmp.push({
        id: Number(element),
        name: chartsList[element].name,
        type: chartsList[element].type,
        granularity: chartsList[element].granularity,
        version: chartsList[element].version,
      });
    }
    setExistingcharts(existingchartstmp);
  }, [chartsList]);

  useEffect(() => {
    let tmpchartsdata = existingcharts.filter((item) =>
      !charts || !charts.find((x) => x.id == item.id) //que les charts qui ne sont pas déjà dans la liste 
    );
    setExistingChartsData(tmpchartsdata);
  }, [charts, existingcharts]);

  // console.log(charts);
  // console.log(existingcharts);
  // console.log(existingChartsData);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (!name || !column
      // || !groups || groups.length === 0 || groups === '0'
    )
      setButtonDisabled(true);
    else
      setButtonDisabled(false);
  });



  const chartsColumns = [
    {
      name: vuepagetext.position,
      selector: (row) => row.position,
      sortable: true,
      maxWidth: "6rem",
      cell: (row) => row.position,
    },
    {
      name: vuepagetext.chartname,
      selector: (row) => row.name,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) =>
        row.source === 'existing' ? (existingcharts.find((x) => x.id == row.id)?.name || 'Graphique hors périmètre') : row.name
    },
    // {
    //   name: campaigncharttext.source,
    //   selector: (row) => row.source,
    //   sortable: true,
    //   maxWidth: "12rem",
    //   cell: (row) => chartsourceData.find((x) => x.id == row.source)?.name || ""
    // },
    {
      name: vuepagetext.charttype,
      selector: (row) => row.type,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => row.source === 'existing' ? charttypefullData.find((a) => a.id == (existingcharts.find((x) => x.id == row.id)?.type))?.name || "" :
        charttypefullData.find((x) => x.id == row.type)?.name || ""
    },
    {
      name: vuepagetext.chartgranularity,
      selector: (row) => row.granularity,
      sortable: true,
      cell: (row) => row.source === 'existing' ? chartgranularityfullData.find((a) => a.id == (existingcharts.find((x) => x.id == row.id)?.granularity))?.name || "" :
        chartgranularityData.find((x) => x.id == row.granularity)?.name || ""
    },
    {
      name: "",
      sortable: false,
      width: "12rem",
      cell: (row) => (
        <>
          <div className="actions-right">
            <Tooltip title="Monter la position">
              <EditButton
                onClick={upChart(row)}
                color={"info"}
                className={classes2.actionButton}
                disabled={row.position == 1}
              >
                <ArrowDropUpIcon fontSize="large" />
              </EditButton>
            </Tooltip>
            <Tooltip title="Descendre la position">
              <EditButton
                onClick={downChart(row)}
                color={"info"}
                className={classes2.actionButton}
                disabled={row.position == charts.length}
              >
                <ArrowDropDownIcon fontSize="large" />
              </EditButton>
            </Tooltip>
            {/* <Tooltip title="Editer le graphique">
              <EditButton
                onClick={editChart(row)}
                color={"warning"}
                className={classes2.actionButton}
                disabled={row.source === 'existing'}
              >
                <EditIcon fontSize="large" />
              </EditButton>
            </Tooltip> */}
            <Tooltip title="Supprimer le graphique de la vue">
              <CustomDeleteButton
                deleteTitle={"Suppression du graphique"}
                deleteSubTitle={`Êtes-vous sûr de vouloir supprimer le graphique de la vue?`}
                handleSupprimer={deleteChartFromViewFunction(row)}
              />
            </Tooltip>
          </div>
        </>
      ),
    },
  ]

  const upChart = (row) => async () => {
    let newcharts = [...charts];
    let obj = newcharts.find((o) => o.id === row.id);
    let oldposition = obj.position;
    let newposition = oldposition - 1; //ie 3 -> 2
    let replacedchart = newcharts.find((o) => o.position === newposition);
    obj.position = newposition;
    replacedchart.position = oldposition;
    setCharts(newcharts);
    currentView.charts = newcharts;
    setModification(true);
  }

  const downChart = (row) => async () => {
    let newcharts = [...charts];
    let obj = newcharts.find((o) => o.id === row.id);
    let oldposition = obj.position;
    let newposition = oldposition + 1; //ie 3 -> 4
    let replacedchart = newcharts.find((o) => o.position === newposition);
    obj.position = newposition;
    replacedchart.position = oldposition;
    setCharts(newcharts);
    currentView.charts = newcharts;
    setModification(true);
  }

  const handleClickOpenChart = () => {
    setOpenchart(true);
  };
  const handleEditCloseChart = () => {
    setOpenchart(false);
  };

  const editChart = (row) => async () => {
    let obj = charts.find((o) => o.id === row.id);
    if (obj) {
      setCurrentchart(obj);
      handleClickOpenChart();
    }
  }
  const deleteChartFromViewFunction = (row) => async () => {
    let newcharts = charts.filter((o) => o.id !== row.id);
    setCharts(newcharts);
    currentView.charts = newcharts;
    setModification(true);
  };

  const [filterTextChart, setFilterTextChart] = useState("");
  const [resetPaginationToggleChart, setResetPaginationToggleChart] = useState(false);
  const SearchComponentChart = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px", marginRight: "10px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  // const filteredItemsChart = charts;
  const filteredItemsChart = charts.filter(
    (item) =>
    (item.id && item.source === 'existing'
      && (existingcharts.find((x) => x.id == item.id)?.name.toLowerCase().includes(filterTextChart.toLowerCase())
        || ('Graphique hors périmètre').toLowerCase().includes(filterTextChart.toLowerCase())))
  );
  const subHeaderComponentMemoChart = useMemo(() => {
    const handleClearChart = () => {
      if (filterTextChart) {
        setResetPaginationToggleChart(!resetPaginationToggleChart);
        setFilterTextChart("");
      }
    };
    const onFilterTextChart = (e) => setFilterTextChart(e.target.value);

    return (
      <>
        <TableName>Graphiques de la vue</TableName>
        <SearchComponentChart
          key="SearchComponentChart"
          onFilter={onFilterTextChart}
          onClear={handleClearChart}
          filterText={filterTextChart}
        />

        <>
          <UploadButton type="button" onClick={handleClearChart}>
            <AddChartToView
              onClick={handleClearChart}
              existingChartsData={existingChartsData}
              // points={points}
              setCharts={setCharts}
              currentView={currentView}
              charts={charts}
              currentchart={currentchart}
              setModification={setModification}
            />
          </UploadButton>
        </>

      </>
    );
  }, [filterTextChart, resetPaginationToggleChart, charts, existingChartsData]);

  console.log(charts);

  return (
    <>
      <CustomDialogTitle id="customized-dialog-title" onClose={closeModal}>
        Edition de la vue {name}
      </CustomDialogTitle>
      <DialogContent dividers style={{ height: "90vh" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <form className={classes.root}>
              <GridContainer>
                <GridItem xs={12} sm={6} md={7} lg={7}>
                  <div>
                    <TextInput
                      isRequired
                      inputTitle={vuepagetext.viewname}
                      textInput={name}
                      handleTextInputChange={handleNameChange}
                    />
                  </div>
                  {/* <div>
                    <DateInput
                      inputTitle={campaignviewtext.datebegin}
                      dateInput={datebegin}
                      handleDateInputChange={handleDatebeginChange}
                    />
                  </div>
                  <div>
                    <DateInput
                      inputTitle={campaignviewtext.dateend}
                      dateInput={dateend}
                      handleDateInputChange={handleDateendChange}
                    />
                  </div> */}
                  <div>
                    <IntInput
                      inputTitle={vuepagetext.columns}
                      intInput={column}
                      handleIntInputChange={handleColumnChange}
                    />
                  </div>
                </GridItem>
                {/* <GridItem xs={12} sm={6} md={5} lg={5}>
                  <div
                    className={classes.treeVisible}
                  >
                    <TreeLabel>Groupe par défaut</TreeLabel>
                    <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                      <EmbeddedEntitesTree
                        selectedIds={handleGroupsChange}
                        userSelectedIds={groups}
                        filterfromnode={campaigngroup}
                      />
                    </ImageList>
                  </div>
                </GridItem> */}
              </GridContainer>
            </form>
          </GridItem>

          <GridItem xs={12} sm={12} md={12}>
            <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
              noDataComponent={<NoData>{"Aucun graphique"}</NoData>}
              noHeader={true}
              columns={chartsColumns}
              persistTableHead
              pagination
              subHeader
              data={filteredItemsChart}
              paginationComponentOptions={{
                noRowsPerPage: false,
                rowsPerPageText: "Lignes par page",
                rangeSeparatorText: "sur",
                selectAllRowsItem: false,
                selectAllRowsItemText: "Selectionner toutes les lignes",
              }}
              defaultPageSize={10}
              filterable={true}
              defaultSortFieldId={1}
              manual={true}
              paginationResetDefaultPage={setResetPaginationToggleChart}
              subHeaderComponent={subHeaderComponentMemoChart}
            />
          </GridItem>
        </GridContainer>

      </DialogContent>
      {/* <DialogActions>
        <Button
          disabled={buttonDisabled}
          className={
            buttonDisabled
              ? classes.submitButtonDisabled
              : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Valider
        </Button>
      </DialogActions> */}
      {/* <Dialog
        onClose={handleEditCloseChart}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="sm"
        open={openchart}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditCloseChart}>
          Edition d'un graphique
        </CustomDialogTitle>
        <DialogContent dividers>
           <ChartDialog
            closeModal={handleEditCloseChart}
            existingChartsData={existingChartsData}
            points={points}
            setCharts={setCharts}
            charts={charts}
            currentchart={currentchart}
          /> 
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog> */}
    </>
  );
}

export default ViewEditionDialog;
